/**
 * Product-code → description parser for PO line items.
 *
 * Customer convention (Feb 2026):
 *   NS12016  → "Natural Shade - 120GSM - 16BF"   (NS prefix + 3-digit GSM + 2-digit BF)
 *   NS18024  → "Natural Shade - 180GSM - 24BF"
 *   IMP170   → "Imported - 170GSM"                (IMP prefix + 3-digit GSM, no BF)
 *   IMP20042 → "Imported - 200GSM - 42BF"          (some IMP codes carry BF too)
 *   D250     → "Duplex - 250GSM"                   (D prefix + 3-digit GSM, no BF)
 *   GYT14018 → "GYT - 140GSM - 18BF"
 *
 * Adding a new prefix? Append a row to PREFIX_MAP. Order matters — longer
 * prefixes must be checked before shorter ones (GYT before G, IMP before I).
 */
const PREFIX_MAP = [
  { prefix: "GYT", label: "GYT" },
  { prefix: "IMP", label: "Imported" },
  { prefix: "NS",  label: "Natural Shade" },
  { prefix: "D",   label: "Duplex" },
];

export const describeProductCode = (rawCode) => {
  if (!rawCode || typeof rawCode !== "string") return "";
  const code = rawCode.trim().toUpperCase();

  for (const { prefix, label } of PREFIX_MAP) {
    if (!code.startsWith(prefix)) continue;
    const digits = code.slice(prefix.length).replace(/[^0-9]/g, "");
    if (digits.length === 0) return label;
    // First 3 digits = GSM. Anything after the first 3 = BF.
    const gsm = digits.slice(0, 3);
    const bf = digits.slice(3);
    if (bf.length === 0) return `${label} - ${gsm}GSM`;
    return `${label} - ${gsm}GSM - ${bf}BF`;
  }
  // Unknown prefix — return the code unchanged so the user can edit manually.
  return rawCode;
};

export default describeProductCode;
